import {
  UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS,
  UPDATEORADDCUSTOMERBANKDETAILS_FAILED,
  RESET_UPDATEORADDCUSTOMERBANKDETAILS,
  LOADING_UPDATEORADDCUSTOMERBANKDETAILS,
  NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateCustomerBankDetails = () => {
  return { type: RESET_UPDATEORADDCUSTOMERBANKDETAILS };
};

const updateCustomerBankDetailsReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UPDATEORADDCUSTOMERBANKDETAILS });
  await partnerServices
    .post(
      "updateOrAddCustomerBankDetails", userData, { headers: { AuthToken: authTokenIs } }
    )
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(updateCustomerBankDetailssuccess(res.data));
          break;
        default:
          dispatch(updateCustomerBankDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_UPDATEORADDCUSTOMERBANKDETAILS,
        payload: err,
      });
    });
};

function updateCustomerBankDetailssuccess(data) {
  return {
    type: UPDATEORADDCUSTOMERBANKDETAILS_SUCCESS,
    payload: data,
  };
}
function updateCustomerBankDetailsFailed(data) {
  return {
    type: UPDATEORADDCUSTOMERBANKDETAILS_FAILED,
    payload: data,
  };
}

export { resetUpdateCustomerBankDetails, updateCustomerBankDetailsReq };